const AIAvatarError = ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        {/* Antenna */}
        <path d="M12 2V5" className="stroke" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="2" r="1.5" className="fill" />

        {/* Robot Head */}
        <rect x="3" y="5" width="18" height="16" rx="5" className="head" strokeWidth="2" />

        {/* Ears */}
        <path d="M1 10H3" className="stroke" strokeWidth="2" strokeLinecap="round" />
        <path d="M21 10H23" className="stroke" strokeWidth="2" strokeLinecap="round" />

        {/* Left X eye */}
        <path d="M7.5 10L10.5 13" className="stroke" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M10.5 10L7.5 13" className="stroke" strokeWidth="1.5" strokeLinecap="round" />

        {/* Right X eye */}
        <path d="M13.5 10L16.5 13" className="stroke" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M16.5 10L13.5 13" className="stroke" strokeWidth="1.5" strokeLinecap="round" />

        {/* Wavy mouth */}
        <path
            d="M8 16C9 16.5 10 15.5 11 16C12 16.5 13 15.5 14 16C15 16.5 16 16 16 16"
            className="stroke"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default AIAvatarError
